import { useStore } from "effector-react";
import { useEffect, useState } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { ClickMesh } from "../../../../common/UI/ClickMesh/organoids/ClickMesh";
import { CeprItem } from "../atoms/CeprModel";
import { $ReadenModelSlides } from "../../../../common/UI/GuideButtons/logic/GuideLogic";
import { IScene, Ipoint3D } from "../../../../common/interfaces";

export const Scene = (params: IScene) => {
    
  const pos = new THREE.Vector3();
  const readenModelSlides = useStore($ReadenModelSlides);
  const [newPosition, setNewPosition] = useState({ x: 0, y: 0, z: 0 });
  const [zoom, setZoom] = useState(false);
  useEffect(() => {
    let point = {} as Ipoint3D | undefined;
    switch (params.selected) {
      case "Правая секция":
        params.setHelper(false);
        setNewPosition({
          x: 2526.5651526448573,
          y: 566.3885998851273,
          z: 1419.5148125191351,
        });
        setZoom(true);
        setTimeout(() => {
          point = params.points.find((e) => e.title === params.selected);
          params.setPosition(
            814,
            313,
            point!.img!,
            point!.title,
            point!.text,
            point!.imgArray!,
            0,
            point!.list!
          );
          params.setModalPoints(point!.points);
        }, 300);
        break;
      case "Подсистема хранения данных и визуализации":
        params.setHelper(false);
        setNewPosition({
          x: 53.58777393057189,
          y: 444.3309142071985,
          z: 2918.7408601596494,
        });
        setZoom(true);
        setTimeout(() => {
          point = params.points.find((e) => e.title === params.selected);
          params.setPosition(
            762,
            239,
            point!.img!,
            point!.title,
            point!.text,
            point!.imgArray!,
            1,
            point!.list!
          );
          params.setModalPoints(point!.points);
        }, 300);
        break;
      case "Основные функции":
        params.setHelper(false);
        setNewPosition({
          x: -1466.5357689328357,
          y: 1225.509616726844,
          z: 2250.9439880528257,
        });
        setZoom(true);
        setTimeout(() => {
          point = params.points.find((e) => e.title === params.selected);
          params.setPosition(
            807,
            228,
            point!.img!,
            point!.title,
            point!.text,
            point!.imgArray!,
            0,
            point!.list!
          );
          params.setModalPoints(point!.points);
        }, 300);
        break;
      case "Левая секция":
        params.setHelper(false);
        setNewPosition({
          x: -2941.102424669141,
          y: 247.50285748041262,
          z: -89.49124395668454,
        });
        setZoom(true);
        setTimeout(() => {
          point = params.points.find((e) => e.title === params.selected);
          params.setPosition(
            764,
            309,
            point!.img!,
            point!.title,
            point!.text,
            point!.imgArray!,
            0,
            point!.list!
          );
          params.setModalPoints(point!.points);
        }, 300);
        break;
      case "Задняя секция":
        params.setHelper(false);
        setNewPosition({
          x: 209.54065766750028,
          y: 893.6892091811459,
          z: -3395.74311074965,
        });
        setZoom(true);
        setTimeout(() => {
          point = params.points.find((e) => e.title === params.selected);
          params.setPosition(
            764,
            309,
            point!.img!,
            point!.title,
            point!.text,
            point!.imgArray!,
            1,
            point!.list!
          );
          params.setModalPoints(point!.points);
        }, 300);
        break;
    }
    switch (params.selected) {
      case "Rechte Sektion":
        params.setHelper(false);
        setNewPosition({
          x: 2526.5651526448573,
          y: 566.3885998851273,
          z: 1419.5148125191351,
        });
        setZoom(true);
        setTimeout(() => {
          point = params.points.find((e) => e.title === params.selected);
          params.setPosition(
            814,
            313,
            point!.img!,
            point!.title,
            point!.text,
            point!.imgArray!,
            0,
            point!.list!
          );
          params.setModalPoints(point!.points);
        }, 300);
        break;
      case "Subsystem für Datenspeicherung und Visualisierung":
        params.setHelper(false);
        setNewPosition({
          x: 53.58777393057189,
          y: 444.3309142071985,
          z: 2918.7408601596494,
        });
        setZoom(true);
        setTimeout(() => {
          point = params.points.find((e) => e.title === params.selected);
          params.setPosition(
            762,
            239,
            point!.img!,
            point!.title,
            point!.text,
            point!.imgArray!,
            1,
            point!.list!
          );
          params.setModalPoints(point!.points);
        }, 300);
        break;
      case "Hauptfunktionen":
        params.setHelper(false);
        setNewPosition({
          x: -1466.5357689328357,
          y: 1225.509616726844,
          z: 2250.9439880528257,
        });
        setZoom(true);
        setTimeout(() => {
          point = params.points.find((e) => e.title === params.selected);
          params.setPosition(
            807,
            228,
            point!.img!,
            point!.title,
            point!.text,
            point!.imgArray!,
            0,
            point!.list!
          );
          params.setModalPoints(point!.points);
        }, 300);
        break;
      case "Linke Sektion":
        params.setHelper(false);
        setNewPosition({
          x: -2941.102424669141,
          y: 247.50285748041262,
          z: -89.49124395668454,
        });
        setZoom(true);
        setTimeout(() => {
          point = params.points.find((e) => e.title === params.selected);
          params.setPosition(
            764,
            309,
            point!.img!,
            point!.title,
            point!.text,
            point!.imgArray!,
            0,
            point!.list!
          );
          params.setModalPoints(point!.points);
        }, 300);
        break;
      case "Rückseite Section":
        params.setHelper(false);
        setNewPosition({
          x: 209.54065766750028,
          y: 893.6892091811459,
          z: -3395.74311074965,
        });
        setZoom(true);
        setTimeout(() => {
          point = params.points.find((e) => e.title === params.selected);
          params.setPosition(
            764,
            309,
            point!.img!,
            point!.title,
            point!.text,
            point!.imgArray!,
            1,
            point!.list!
          );
          params.setModalPoints(point!.points);
        }, 300);
        break;
    }
    switch (params.selected) {
      case "Right section":
        params.setHelper(false);
        setNewPosition({
          x: 2526.5651526448573,
          y: 566.3885998851273,
          z: 1419.5148125191351,
        });
        setZoom(true);
        setTimeout(() => {
          point = params.points.find((e) => e.title === params.selected);
          params.setPosition(
            814,
            313,
            point!.img!,
            point!.title,
            point!.text,
            point!.imgArray!,
            0,
            point!.list!
          );
          params.setModalPoints(point!.points);
        }, 300);
        break;
      case "Data Storage and Visualization Subsystem marker":
        params.setHelper(false);
        setNewPosition({
          x: 53.58777393057189,
          y: 444.3309142071985,
          z: 2918.7408601596494,
        });
        setZoom(true);
        setTimeout(() => {
          point = params.points.find((e) => e.title === params.selected);
          params.setPosition(
            762,
            239,
            point!.img!,
            point!.title,
            point!.text,
            point!.imgArray!,
            1,
            point!.list!
          );
          params.setModalPoints(point!.points);
        }, 300);
        break;
      case "Functions marker":
        params.setHelper(false);
        setNewPosition({
          x: -1466.5357689328357,
          y: 1225.509616726844,
          z: 2250.9439880528257,
        });
        setZoom(true);
        setTimeout(() => {
          point = params.points.find((e) => e.title === params.selected);
          params.setPosition(
            807,
            228,
            point!.img!,
            point!.title,
            point!.text,
            point!.imgArray!,
            0,
            point!.list!
          );
          params.setModalPoints(point!.points);
        }, 300);
        break;
      case "Left section":
        params.setHelper(false);
        setNewPosition({
          x: -2941.102424669141,
          y: 247.50285748041262,
          z: -89.49124395668454,
        });
        setZoom(true);
        setTimeout(() => {
          point = params.points.find((e) => e.title === params.selected);
          params.setPosition(
            764,
            309,
            point!.img!,
            point!.title,
            point!.text,
            point!.imgArray!,
            0,
            point!.list!
          );
          params.setModalPoints(point!.points);
        }, 300);
        break;
      case "Back section":
        params.setHelper(false);
        setNewPosition({
          x: 209.54065766750028,
          y: 893.6892091811459,
          z: -3395.74311074965,
        });
        setZoom(true);
        setTimeout(() => {
          point = params.points.find((e) => e.title === params.selected);
          params.setPosition(
            764,
            309,
            point!.img!,
            point!.title,
            point!.text,
            point!.imgArray!,
            1,
            point!.list!
          );
          params.setModalPoints(point!.points);
        }, 300);
        break;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.selected]);

  useFrame((state) => {
    if (zoom) {
      pos.set(newPosition.x, newPosition.y, newPosition.z);
      state.camera.position.lerp(pos, 0.1);
      state.camera.updateProjectionMatrix();
    }
  });

  useEffect(() => {
    if (zoom) {
      setTimeout(() => {
        setZoom((zoom) => !zoom);
      }, 500);
    }
  }, [zoom]);
  
  useEffect(() => {
    params.setHelper(true);
    setInterval(() => {
      params.setHelper(false);
    }, 8000);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <pointLight intensity={1} color="white" position={[1850, 1050, 0]} />
      <pointLight intensity={1} color="white" position={[0, 1050, -1850]} />
      <pointLight intensity={1} color="white" position={[-1850, 1050, 0]} />
      <pointLight intensity={1} color="white" position={[0, 1050, 1850]} />
      {params.points.slice(0, readenModelSlides + 1).map((e, i) => {
        return (
          <ClickMesh
            setSelected={params.setSelected}
            key={i}
            title={e.title}
            posX={e.posX}
            posY={e.posY}
            posZ={e.posZ}
            scaleX={10}
            scaleY={10}
            scaleZ={10}
          />
        );
      })}
      <CeprItem />
    </>
  );
};
